import { convertImpacts } from "./impacts";
/**
 * Cleans the raw company data from the API.
 *
 * @param rawData The raw company data from the API.
 * @returns The cleaned company data.
 */
export function cleanCompanyData(rawData) {
    const { data } = rawData;
    const impacts = convertImpacts(data.impacts, data.trees_by_forest_types);
    const treesByForestTypes = data.trees_by_forest_types.map((forestType) => ({
        id: forestType.forest_type_id,
        name: forestType.type,
        ordered: forestType.trees_ordered,
        planted: forestType.trees_planted,
        designated: forestType.trees_designated,
    }));
    const countries = data.countries;
    const trees = {
        ordered: data.trees_ordered,
        planted: data.trees_planted,
        designated: data.trees_designated,
    };
    return {
        impacts,
        treesByForestTypes,
        countries,
        trees,
    };
}
/**
 * Cleans the raw planting data from the API.
 *
 * @param rawData The raw planting data from the API.
 * @returns The cleaned planting data.
 */
export function cleanPlantingData(rawData) {
    console.log(rawData);
    return rawData.map(cleanCountry);
}
/**
 * Cleans the raw country data.
 *
 * @param raw The raw country data.
 * @returns The cleaned country data.
 */
function cleanCountry(raw) {
    const { id, name, lat, long, regions } = raw;
    return {
        id,
        name,
        lat,
        long,
        regions: regions.map(cleanRegion),
    };
}
/**
 * Cleans the raw region data.
 *
 * @param raw The raw region data.
 * @returns The cleaned region data.
 */
function cleanRegion(raw) {
    const { id, name, center_lat, center_long, organization, subsites } = raw;
    return {
        id,
        name,
        lat: center_lat,
        long: center_long,
        organization,
        subSites: subsites.map(cleanSubSite),
    };
}
/**
 * Cleans the raw subsite data.
 *
 * @param raw The raw subsite data.
 * @returns The cleaned subsite data.
 */
function cleanSubSite(raw) {
    const { id, name, description, geofence: rawGeofence, site_manager_name, site_manager_title, type, forest_type_name, forest_type_id, total_planters, trees_designated, trees_ordered, trees_planted, kelp_designated, kelp_ordered, kelp_planted, subsite_area, } = raw;
    const counts = type === "Trees"
        ? {
            designated: trees_designated,
            ordered: trees_ordered,
            planted: trees_planted,
        }
        : {
            designated: kelp_designated,
            ordered: kelp_ordered,
            planted: kelp_planted,
        };
    const geofence = rawGeofence
        ? {
            type: rawGeofence.type,
            coordinates: convertCoordinates(rawGeofence.coordinates),
        }
        : undefined;
    return {
        id,
        name,
        description,
        geofence,
        manager: {
            name: site_manager_name,
            title: site_manager_title,
        },
        type,
        forestType: {
            id: forest_type_id,
            name: forest_type_name,
        },
        numberOfPlanters: total_planters,
        image: getSubSiteImage(raw),
        area: subsite_area,
        counts,
    };
}
/**
 * Gets the image for a subsite.
 *
 * @param subsite The subsite to get the image for.
 * @returns The image for the subsite or null if undefined.
 */
export function getSubSiteImage(subsite) {
    var _a;
    return ((_a = subsite.subsite_main_image_url) === null || _a === void 0 ? void 0 : _a.cdn_url) || null;
}
/**
 * Converts the raw coordinates to the format used by Leaflet.
 *
 * @param raw The raw coordinates.
 * @returns The converted coordinates.
 */
function convertCoordinates(raw) {
    return raw.map((polygon) => polygon.map((ring) => ring.map(([lng, lat]) => [lat, lng])));
}
